export default __webpack_public_path__ + "static/media/map.ca40977d.svg";